import { getServerlessImageHandlerUrl } from '~/components/Image/helpers'
import { Breakpoint, useCheckBreakpoint } from '~/utils'

export default function useBackground(): string {
  const isSmallScreen = useCheckBreakpoint({ lt: Breakpoint.MD })
  const bgDesktop = getServerlessImageHandlerUrl({
    key: 'donation/background-ukraine-desktop.png',
    edits: {
      resize: {
        fit: 'cover',
        width: 890,
        height: 599,
      },
    },
  })
  const bgMobile = getServerlessImageHandlerUrl({
    key: 'donation/background-ukraine-desktop.png',
    edits: {
      resize: {
        fit: 'cover',
        width: 310,
        height: 209,
      },
    },
  })

  return isSmallScreen ? bgMobile : bgDesktop
}
